import React, { Component } from "react";
import { connect } from "react-redux";
import { openTopicViewer } from "Actions";

import TopicComponent from "./TopicComponent";

export class TopicContainer extends Component {
  handleOpenTopicReveal = e => {
    const { openTopicViewer, topic } = this.props;

    openTopicViewer({
      topics: [topic],
      isOpen: true,
      currentTopic: topic
    });
  };
  render() {
    const { community, topic, language } = this.props;

    return (
      <TopicComponent
        topic={topic}
        community={community}
        language={language}
        openTopicReveal={this.handleOpenTopicReveal}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  language: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  openTopicViewer: viewer => dispatch(openTopicViewer(viewer))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopicContainer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Topic/TopicContainer.js